export const nullOrValue = (urlParam: string): string | null => {
    if (!urlParam || urlParam === 'null') {
        return null;
    }
    return urlParam;
};
